var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D83F87;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.9,51.2h-16.4V26.6c0-12.3-8.2-20.5-20.5-20.5s-20.5,8.2-20.5,20.5v24.6h-47.1V26.6 c0-12.3-8.2-20.5-20.5-20.5c-12.3,0-20.5,8.2-20.5,20.5v24.6h-47.1V26.6c0-12.3-8.2-20.5-20.5-20.5s-20.5,8.2-20.5,20.5v24.6h-45.1 V26.6c0-12.3-8.2-20.5-20.5-20.5s-20.5,8.2-20.5,20.5v24.6H88.1c-43,0-77.8,34.8-77.8,77.8v299c0,43,34.8,77.8,77.8,77.8h335.9 c43,0,77.8-34.8,77.8-77.8V129c0-16.4-4.1-30.7-14.3-43C475.1,63.5,450.6,51.2,423.9,51.2L423.9,51.2z M460.8,428 c0,20.5-16.4,36.9-36.9,36.9H88.1c-20.5,0-36.9-16.4-36.9-36.9V190.5h409.6V428z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.6,309.2h53.2c6.1,0,12.3-6.1,12.3-12.3v-53.2c0-6.1-6.1-12.3-12.3-12.3h-53.2c-6.1,0-12.3,6.1-12.3,12.3 V297C96.3,303.1,102.4,309.2,110.6,309.2z M229.4,309.2h53.2c6.1,0,12.3-6.1,12.3-12.3v-53.2c0-6.1-6.1-12.3-12.3-12.3h-53.2 c-6.1,0-12.3,6.1-12.3,12.3V297C217.1,303.1,223.2,309.2,229.4,309.2L229.4,309.2z M348.2,309.2h53.2c6.1,0,12.3-6.1,12.3-12.3 v-53.2c0-6.1-6.1-12.3-12.3-12.3h-53.2c-6.1,0-12.3,6.1-12.3,12.3V297C335.9,303.1,342,309.2,348.2,309.2z M110.6,430.1h53.2 c6.1,0,12.3-6.1,12.3-12.3v-53.2c0-6.1-6.1-12.3-12.3-12.3h-53.2c-6.1,0-12.3,6.1-12.3,12.3v53.2 C96.3,423.9,102.4,430.1,110.6,430.1z M229.4,430.1h53.2c6.1,0,12.3-6.1,12.3-12.3v-53.2c0-6.1-6.1-12.3-12.3-12.3h-53.2 c-6.1,0-12.3,6.1-12.3,12.3v53.2C217.1,423.9,223.2,430.1,229.4,430.1L229.4,430.1z M348.2,430.1h53.2c6.1,0,12.3-6.1,12.3-12.3 v-53.2c0-6.1-6.1-12.3-12.3-12.3h-53.2c-6.1,0-12.3,6.1-12.3,12.3v53.2C335.9,423.9,342,430.1,348.2,430.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointment);
export default __webpack_public_path__ + "static/media/appointment.14bea0afb5ac9d0beeb5981f2d25745d.svg";
export { ForwardRef as ReactComponent };